"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGraphqlErrors = void 0;
var get_value_1 = __importDefault(require("get-value"));
var parseGraphqlErrors = function (graphQLErrors) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var e = graphQLErrors;
    var catchError = (0, get_value_1.default)(e, 'networkError.result.errors.0.message');
    var inputError = (0, get_value_1.default)(e, '0.extensions.exception.response.message.0');
    var message = (0, get_value_1.default)(e, 'message');
    var bagError = (0, get_value_1.default)(e, '0.message');
    return catchError || inputError || bagError || message;
};
exports.parseGraphqlErrors = parseGraphqlErrors;
